import { render, staticRenderFns } from "./zhongfu.vue?vue&type=template&id=f6db1df4&scoped=true&"
import script from "./zhongfu.vue?vue&type=script&lang=js&"
export * from "./zhongfu.vue?vue&type=script&lang=js&"
import style0 from "./zhongfu.vue?vue&type=style&index=0&id=f6db1df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6db1df4",
  null
  
)

export default component.exports